import { ProductOptionalFieldNameEnum as POFNE } from '@inter-ikea-kompis/enums';
export const getProductFields = () => [
    POFNE.genericProduct,
    POFNE.image,
    POFNE.measure,
    POFNE.measureReference,
    POFNE.priceInformation,
    POFNE.appConfig,
    POFNE.child
];
//# sourceMappingURL=productFields.js.map